module.exports = __webpack_public_path__ + "static/media/favor.ab73de91.svg";